import React from 'react';
import './IngredientCheckerLanding.css';

const IngredientCheckerLanding = () => {
  const features = [
    {
      icon: '📷',
      title: '성분표 스캔',
      description: '카메라로 제품 성분표를 촬영하면 자동으로 성분을 인식합니다',
      color: '#EA580C'
    },
    {
      icon: '🤖',
      title: 'AI 성분 분석',
      description: '복잡한 화학 성분명을 쉬운 말로 설명해드립니다',
      color: '#F97316'
    },
    {
      icon: '⚠️',
      title: '유해 성분 경고',
      description: '주의가 필요한 성분을 한눈에 확인할 수 있습니다',
      color: '#FB923C'
    },
    {
      icon: '💡',
      title: '대체 제품 추천',
      description: '더 안전한 대체 제품을 추천해드립니다',
      color: '#FDBA74'
    }
  ];

  const benefits = [
    { icon: '⚡', text: '3초 성분 분석' },
    { icon: '🔍', text: '유해 성분 즉시 확인' },
    { icon: '🛡️', text: '알레르기 성분 경고' },
    { icon: '📊', text: '안전 등급 표시' },
    { icon: '💊', text: '식품/화장품 지원' },
    { icon: '👨‍👩‍👧‍👦', text: '가족 알레르기 관리' }
  ];

  return (
    <div className="ic-container">
      {/* Hero Section */}
      <section className="ic-hero">
        <div className="ic-hero-content">
          <div className="ic-hero-badge">🧪 AI 성분 분석</div>
          <h1 className="ic-hero-title">
            이 성분, 괜찮을까?<br />
            <span className="ic-gradient-text">AI가 바로 알려드려요</span>
          </h1>
          <p className="ic-hero-description">
            식품, 화장품의 성분표를 촬영하면<br />
            AI가 유해 성분을 분석해드립니다
          </p>
          <div className="ic-hero-buttons">
            <button className="ic-btn-primary">
              무료로 시작하기
            </button>
            <button className="ic-btn-secondary">
              자세히 알아보기
            </button>
          </div>
          <div className="ic-hero-stats">
            <div className="ic-stat-item">
              <span className="ic-stat-number">10,000+</span>
              <span className="ic-stat-label">등록 성분</span>
            </div>
            <div className="ic-stat-item">
              <span className="ic-stat-number">3초</span>
              <span className="ic-stat-label">분석 시간</span>
            </div>
            <div className="ic-stat-item">
              <span className="ic-stat-number">99%</span>
              <span className="ic-stat-label">인식 정확도</span>
            </div>
          </div>
        </div>
        <div className="ic-hero-image">
          <div className="ic-phone-mockup">
            <img src="/api/placeholder/300/600" alt="성분체크 앱 화면" />
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="ic-features">
        <div className="ic-section-header">
          <h2>핵심 기능</h2>
          <p>스캔부터 분석까지, 성분 확인을 위한 종합 도구</p>
        </div>
        <div className="ic-features-grid">
          {features.map((feature, index) => (
            <div key={index} className="ic-feature-card" style={{'--accent-color': feature.color}}>
              <div className="ic-feature-icon">{feature.icon}</div>
              <h3>{feature.title}</h3>
              <p>{feature.description}</p>
            </div>
          ))}
        </div>
      </section>

      {/* How It Works Section */}
      <section className="ic-how-it-works">
        <div className="ic-how-content">
          <h2>이렇게 사용해요</h2>
          <p>간편한 3단계로 성분을 확인하세요</p>
          <div className="ic-step-cards">
            <div className="ic-step-card">
              <div className="ic-step-number">01</div>
              <h3>촬영하기</h3>
              <p>제품 성분표를 카메라로 촬영하면 OCR이 자동으로 인식합니다</p>
            </div>
            <div className="ic-step-card">
              <div className="ic-step-number">02</div>
              <h3>AI 분석</h3>
              <p>AI가 각 성분의 안전성을 분석하고 쉬운 말로 설명해드립니다</p>
            </div>
            <div className="ic-step-card">
              <div className="ic-step-number">03</div>
              <h3>안심 쇼핑</h3>
              <p>유해 성분 여부를 확인하고 더 안전한 제품을 선택하세요</p>
            </div>
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="ic-benefits">
        <div className="ic-benefits-content">
          <div className="ic-benefits-text">
            <h2>왜 성분체크인가요?</h2>
            <p className="ic-benefits-description">
              어려운 화학 성분명이 아닌,<br />
              쉬운 말로 알려드립니다.
            </p>
            <div className="ic-benefits-list">
              {benefits.map((benefit, index) => (
                <div key={index} className="ic-benefit-item">
                  <span className="ic-benefit-icon">{benefit.icon}</span>
                  <span>{benefit.text}</span>
                </div>
              ))}
            </div>
          </div>
          <div className="ic-benefits-image">
            <img src="/api/placeholder/500/400" alt="성분체크 분석 화면" />
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="ic-cta">
        <div className="ic-cta-content">
          <h2>지금 바로 시작하세요</h2>
          <p>성분 확인, 3초면 충분합니다</p>
          <div className="ic-cta-buttons">
            <button className="ic-btn-download">
              <span>🤖</span> Google Play
            </button>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="ic-footer">
        <div className="ic-footer-content">
          <div className="ic-footer-section">
            <h3>성분체크</h3>
            <p>AI 성분 분석 앱</p>
          </div>
          <div className="ic-footer-section">
            <h4>제품</h4>
            <ul>
              <li><a href="#features">기능</a></li>
              <li><a href="#how-it-works">사용법</a></li>
              <li><a href="#faq">FAQ</a></li>
            </ul>
          </div>
          <div className="ic-footer-section">
            <h4>회사</h4>
            <ul>
              <li><a href="#about">소개</a></li>
              <li><a href="#contact">문의</a></li>
            </ul>
          </div>
          <div className="ic-footer-section">
            <h4>법적 고지</h4>
            <ul>
              <li><a href="/ingredientchecker/terms">이용약관</a></li>
              <li><a href="/ingredientchecker/privacy">개인정보처리방침</a></li>
              <li><a href="/ingredientchecker/account-deletion">계정 삭제</a></li>
            </ul>
          </div>
        </div>
        <div className="ic-footer-bottom">
          <p>&copy; 2026 성분체크(Ingredient Checker). All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
};

export default IngredientCheckerLanding;
